import { setPreference } from '@fs/zion-preferences'
import { useHistory } from '@fs/zion-router'
import { LayoutBand, Paragraph } from '@fs/zion-ui'
import React, { useEffect, useRef, useState } from 'react'
import { useDetailsOptInOutParams } from './detailsOptInOutRouteUtil'
import CenteredLoadingSpinner from '../../common/CenteredLoadingSpinner'

const REDIRECT_COUNTDOWN_SECONDS = 5

export default function SourceCentricDetailsOptInOut(): JSX.Element {
  const { action, pid } = useDetailsOptInOutParams()
  const history = useHistory()
  const hasRun = useRef(false)
  const [message, setMessage] = useState('')
  const [isError, setIsError] = useState(false)
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_COUNTDOWN_SECONDS)

  useEffect(() => {
    if (hasRun.current) return
    hasRun.current = true

    const optIn = action === 'opt-in'
    // opt-in sets true so the banner shows; opt-out clears ('') so the banner is hidden
    setPreference('softLaunch.treeWeb_personR9_sourceCentricDetails', optIn ? true : '')
      .then(() => {
        setMessage(
          optIn
            ? 'You have been opted in to the new details experience.'
            : 'You have been opted out of the new details experience.'
        )
        return undefined
      })
      .catch(() => {
        setIsError(true)
        setMessage(
          optIn
            ? 'There was an error opting in to the new details experience. Please try again later.'
            : 'There was an error opting out of the new details experience. Please try again later.'
        )
      })
  }, [action])

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined

    if (message) {
      if (secondsLeft === 0) {
        history.push(`/details${pid ? `/${pid}` : ''}`)
      } else {
        timer = setTimeout(() => setSecondsLeft((prev) => prev - 1), 1000)
      }
    }

    return () => clearTimeout(timer)
  }, [message, secondsLeft, history, pid])

  return (
    <LayoutBand>
      {!isError && <CenteredLoadingSpinner />}
      {message && (
        <>
          <Paragraph centered color={isError ? 'red' : undefined}>
            {message}
          </Paragraph>
          <Paragraph centered>
            Redirecting to details in {secondsLeft} second{secondsLeft !== 1 ? 's' : ''}...
          </Paragraph>
        </>
      )}
    </LayoutBand>
  )
}
